import React, { useEffect, useState } from "react";
import { FaChartBar } from "react-icons/fa";
import DashMedidasSectionCard from "./DashMedidasSectionCard/DashMedidasSectionCard";

const MetricChip = ({ label, value, accent = true, title, truncateValue = false }) => (
  <div className="dash-metric-chip" title={title || (truncateValue ? value : undefined)}>
    <span className="dash-metric-chip__label">{label}</span>
    <span
      className={[
        "dash-metric-chip__value",
        accent ? "dash-metric-chip__value--accent" : "",
        truncateValue ? "dash-metric-chip__value--truncate" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {value}
    </span>
  </div>
);

const formatCurrentCurve = (grain, validity) => {
  if (!grain && !validity) return "Todas";
  if (grain && validity && !String(grain).includes("%")) {
    return `${grain} ${validity}`.trim();
  }
  return grain || validity;
};

const Tables = ({
  serial,
  length,
  mediaph,
  mediapeso,
  mediahumidity,
  curvaSelecionada,
  validadeCurva,
  mediatemperatura,
}) => {
  const hasAnySerial = (serialValue, candidates = []) => {
    if (!serialValue || !candidates || candidates.length === 0) return false;
    if (Array.isArray(serialValue)) {
      return serialValue.some((s) => candidates.some((c) => String(s).includes(c)));
    }
    return candidates.some((c) => String(serialValue).includes(c));
  };

  const [medidas, setMedidas] = useState({
    mediaph,
    mediapeso,
    mediahumidity,
    mediatemperatura,
  });

  useEffect(() => {
    setMedidas({
      mediaph,
      mediapeso,
      mediahumidity,
      mediatemperatura,
    });
  }, [serial, mediaph, mediapeso, mediahumidity, mediatemperatura]);

  const list = ["SEMT", "SIMT", "BIMT", "CPMT", "EEMT"];
  const showCurvas = hasAnySerial(serial, list);
  const hasMeasures = Number(length) > 0;
  const headerRight = hasMeasures ? `${length} medidas` : null;

  const formatAverage = (value, suffix = "") => {
    if (!hasMeasures) return "--";
    if (!Number.isFinite(Number(value))) return `--${suffix}`;
    return `${Number(value).toFixed(1)}${suffix}`;
  };

  const humidityDisplay = formatAverage(medidas.mediahumidity, "%");
  const tempDisplay = formatAverage(medidas.mediatemperatura, "°C");
  const phDisplay = formatAverage(medidas.mediaph);
  const pesoDisplay = formatAverage(medidas.mediapeso, "g");
  const curvaDisplay = hasMeasures
    ? formatCurrentCurve(curvaSelecionada, validadeCurva)
    : "--";
  const curvaTitle =
    curvaSelecionada || validadeCurva
      ? `Curva ativa: ${curvaDisplay}`
      : "Nenhuma curva específica — exibindo todas";

  return (
    <DashMedidasSectionCard
      icon={FaChartBar}
      subtitle="Curva e"
      title="Médias"
      headerRight={headerRight}
      collapsible
      sectionId="dash-medias-curvas"
    >
      <div className="dash-metrics-strip">
        <MetricChip
          label="Curva"
          value={curvaDisplay}
          title={curvaTitle}
          accent={!!curvaSelecionada}
          truncateValue
        />
        <MetricChip label="Umidade" value={humidityDisplay} />
        <MetricChip label="Temperatura" value={tempDisplay} />
        {showCurvas && (
          <>
            <MetricChip label="pH / Dens." value={phDisplay} />
            <MetricChip label="Peso" value={pesoDisplay} />
          </>
        )}
        <MetricChip
          label="Medidas"
          value={hasMeasures ? String(length) : "0"}
          accent={false}
        />
      </div>
    </DashMedidasSectionCard>
  );
};

export default Tables;
